import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField } from '../TextField';

const useStyleLabel = makeStyles(() => ({
    filled: {
        color: '#8692A6',
        fontSize: '16px',
        marginBottom: '0 !important',
    },
    focused: {
        color: '#8692A6',
    },
    error: {
        color: '#8692A6 !important',
    },
}));

export const Input = (props) => {
    const labelClasses = useStyleLabel();
    const { InputProps = {}, InputLabelProps = {}, onChange, ...other } = props;
    return (
        <TextField
            InputProps={{
                disableUnderline: true,
                ...InputProps,
            }}
            InputLabelProps={{
                classes: labelClasses,
                ...InputLabelProps,
            }}
            onChange={onChange}
            {...other}
        />
    );
};
